import React, { useEffect, useState } from "react";
import styles from "./DatesTable.style";
import { Text, Div, List } from "@vkontakte/vkui";
import { connect } from "react-redux";
import { selectDay } from "../../../redux/actions/datesActions";
import { setActivePanel } from "../../../redux/actions/panelsActions";
import { panels } from "../../../variables";
import DatesRow from "../DatesRow";
import WeekDayRow from "../WeekDayRow";
import { splitDaysByWeeks } from "../helpers";
import { months_u } from "../../../variables";

const DatesTable = ({
  dates,
  availableDates,
  firstDay,
}) => {
  const [month, setMonth] = useState("");
  const [table, setTable] = useState(null);

  useEffect(() => {
    if (dates[0] && !month.length) {

      //@todo сделать месяц пропсом
      setMonth(months_u[dates[0].getMonth()]);

      const splittedDatesByWeek = splitDaysByWeeks(dates, firstDay);

      setTable(
        <>
          <WeekDayRow firstDay={firstDay}/>
          <List>
            {splittedDatesByWeek.map((datesRow, index) => {
              return (
                <DatesRow
                  dates={datesRow}
                  availableDates={availableDates}
                  key={`row-${index}`}
                />
              );
            })}
          </List>
        </>
      );
    }
    // eslint-disable-next-line 
  }, [dates]);

  return (
    <Div style={{ marginTop: "0", padding: "0" }}>
      {month ? (
        <Text weight={"regular"} style={styles.month}>
          {month}
        </Text>
      ) : null}
      {table}
    </Div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    selectDay: (day) => dispatch(selectDay(day)),
    goToChooseTimePanel: () => dispatch(setActivePanel(panels.chooseTime)),
  };
};

export default connect(null, mapDispatchToProps)(DatesTable);
